import { component } from 'picoapp';
import app from 'app';
import { clear } from 'utils/node';
import { productPlaceholder } from 'utils/placeholders';

export default component(async (node, ctx) => {
  const isShared = node.hasAttribute('data-shared') ?? false;
  const empty = node.querySelector('[data-empty]');
  const itemsContainer = node.querySelector('[data-items]');

  const fetchWishlist = async () => {
    if (isShared) {
      const shared = await window.WishlistKing.toolkit.sharedWishlists.get();
      return shared[0];
    }

    return window.WishlistKing.toolkit.collection.get();
  };

  const reformattedCard = (item, html) => {
    const form = html.querySelector('[data-wishlist-form]');
    const link = html.querySelector('[data-wishlist-link]');
    const action = html.querySelector('[data-actions]');

    if (isShared) clear(action);

    if (form && item.selected_variant_id) {
      const submit = form.querySelector('button[type="submit"]');
      submit.setAttribute('data-wk-add-to-cart', item.wishlist_item_id);

      const selectedVariant = item.variants.find((variant) => (
        variant.id === item.selected_variant_id
      ));

      if (selectedVariant && !selectedVariant.available) {
        html.classList.add('variant-sold-out');
        submit.disabled = true;
        submit.textContent = window.theme.strings.soldOut;
      }

      form.classList.remove('hidden');
      form.id.value = item.selected_variant_id;

      const json = JSON.parse(html.querySelector('[data-wishlist-json]').innerHTML);
      const variant = json.find((v) => v.id === Number(item.selected_variant_id));

      const markup = `
        <span class="btn btn--small btn--light items-center font-medium space-x-1 pointer-events-none">
          <span>${window.theme.strings.product.size}:</span>
          <strong>${variant.options[variant.options.length - 1]}</strong>
        </span>
      `;

      action.insertAdjacentHTML('afterbegin', markup);
    }

    if (!item.selected_variant_id) {
      link.classList.remove('hidden');
    }

    return html;
  };

  const visibility = (items) => {
    if (items.length > 0) {
      itemsContainer.classList.remove('hidden');
      empty.classList.add('hidden');
    } else {
      itemsContainer.classList.add('hidden');
      empty.classList.remove('hidden');
    }
  };

  const renderProducts = async (items) => {
    visibility(items);

    items.forEach(async (item) => {
      const placeholder = productPlaceholder('collection__product');
      itemsContainer.appendChild(placeholder);

      const response = await fetch(`/products/${item.handle}?view=wishlist`);
      const text = await response.text();

      const html = document.createElement('div');
      html.innerHTML = text;

      const reformatted = reformattedCard(item, html.firstChild);
      itemsContainer.replaceChild(reformatted, placeholder);

      app.mount();
    });
  };

  const init = async () => {
    const response = await fetchWishlist();
    ctx.emit('wishlist:loaded', { response });

    clear(itemsContainer);
    await renderProducts(response.products);
  };

  document.addEventListener('wishlist:ready', () => {
    init();
  });

  document.addEventListener('wishlist:render', async () => {
    init();
  });
});
